module.exports = __webpack_public_path__ + "static/elizabeth-fowkes-lg-6407d15856941b6b42f3442a01c74835.png";